if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      // ... (all other properties and methods from your original code) ...
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.(); // Ensure it's callable
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        this.resetProductFormState();
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariantScript = productInfoNode.querySelector('variant-selects [data-selected-variant]');
        if (selectedVariantScript?.innerHTML) {
            try {
                return JSON.parse(selectedVariantScript.innerHTML);
            } catch (e) {
                console.error("Error parsing selected variant JSON:", e, selectedVariantScript.innerHTML);
                return null;
            }
        }
        return null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }
        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects && this.variantSelectors) { // Check if this.variantSelectors exists
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

handleUpdateProductInfo(productUrl) {
  return (html) => {
    const variant = this.getSelectedVariant(html);
    // Add console log from "your code"
    console.log('[ProductInfo] Raw variant object from getSelectedVariant:', variant ? JSON.parse(JSON.stringify(variant)) : 'No variant object');


    this.pickupAvailability?.update(variant);
    this.updateOptionValues(html);
    this.updateURL(productUrl, variant?.id);

    // --- Start: Availability determination logic from "your code" ---
    // Add the isVariantAvailable calculation logic
    let isVariantAvailable;

    if (!variant || typeof variant.id === 'undefined') {
      isVariantAvailable = false;
      console.log('[ProductInfo] Determination: No valid variant object or variant.id is undefined. Setting isVariantAvailable = false.');
    } else {
      const variantId = variant.id;
      if (window.VARIANT_INVENTORY && typeof window.VARIANT_INVENTORY === 'object') {
        const inventoryQuantity = window.VARIANT_INVENTORY[variantId];
        console.log(`[ProductInfo] Checking window.VARIANT_INVENTORY for variant ID: ${variantId}. Raw Quantity from global: ${inventoryQuantity}`);
        if (typeof inventoryQuantity === 'number') {
          if (variant.inventory_policy === 'continue') {
            isVariantAvailable = true;
            console.log(`[ProductInfo] Determination: Using window.VARIANT_INVENTORY. Variant ID: ${variantId}, Quantity: ${inventoryQuantity}, BUT inventory_policy is 'continue'. Setting isVariantAvailable = true.`);
          } else {
            isVariantAvailable = inventoryQuantity > 0;
            console.log(`[ProductInfo] Determination: Using window.VARIANT_INVENTORY. Variant ID: ${variantId}, Quantity: ${inventoryQuantity}, Policy: '${variant.inventory_policy || 'deny/unknown'}'. Setting isVariantAvailable = ${isVariantAvailable}.`);
          }
        } else {
          console.warn(`[ProductInfo] WARN: Variant ID ${variantId} not found in window.VARIANT_INVENTORY or quantity is not a number. Falling back.`);
          if (typeof variant.available === 'boolean') {
            isVariantAvailable = variant.available;
            console.log(`[ProductInfo] Fallback 1: Using variant.available property. Value: ${variant.available}. Setting isVariantAvailable = ${isVariantAvailable}.`);
          } else {
            console.log('[ProductInfo] Fallback 1 failed. Falling back to button check.');
            const submitButtonId = `ProductSubmitButton-${this.sectionId}`;
            const submitButtonFromFetchedHtml = html.getElementById(submitButtonId);
            if (!submitButtonFromFetchedHtml) {
              console.error(`[ProductInfo] Fallback 2 ERROR: Submit button with ID '${submitButtonId}' NOT FOUND. Assuming unavailable.`);
              isVariantAvailable = false;
            } else {
              const isDisabled = submitButtonFromFetchedHtml.hasAttribute('disabled');
              isVariantAvailable = !isDisabled;
              console.log(`[ProductInfo] Fallback 2: Button '${submitButtonId}' disabled: ${isDisabled}. Setting isVariantAvailable = ${isVariantAvailable}.`);
            }
          }
        }
      } else {
        console.warn('[ProductInfo] WARN: window.VARIANT_INVENTORY is not defined or not an object. Falling back.');
        if (typeof variant.available === 'boolean') {
          isVariantAvailable = variant.available;
          console.log(`[ProductInfo] Fallback 1: Using variant.available property. Value: ${variant.available}. Setting isVariantAvailable = ${isVariantAvailable}.`);
        } else {
          console.log('[ProductInfo] Fallback 1 failed. Falling back to button check.');
          const submitButtonId = `ProductSubmitButton-${this.sectionId}`;
          const submitButtonFromFetchedHtml = html.getElementById(submitButtonId);
          if (!submitButtonFromFetchedHtml) {
            console.error(`[ProductInfo] Fallback 2 ERROR: Submit button with ID '${submitButtonId}' NOT FOUND. Assuming unavailable.`);
            isVariantAvailable = false;
          } else {
            const isDisabled = submitButtonFromFetchedHtml.hasAttribute('disabled');
            isVariantAvailable = !isDisabled;
            console.log(`[ProductInfo] Fallback 2: Button '${submitButtonId}' disabled: ${isDisabled}. Setting isVariantAvailable = ${isVariantAvailable}.`);
          }
        }
      }
    }
    console.log(`[ProductInfo] ==> Final isVariantAvailable for variant ${variant?.id}: ${isVariantAvailable}`);
    // --- End: Availability determination logic from "your code" ---

    // Call updateVariantInputs, now potentially passing the calculated availability
    // (Assuming updateVariantInputs is updated to handle this, like in "your code"'s version
    // which uses it to toggle the delivery message)
    this.updateVariantInputs(variant?.id, isVariantAvailable); // Pass isVariantAvailable

    // --- Original Scenario Logic for calling setUnavailable based on !variant ---
    // This part remains the same as the "Default code" to preserve its original scenario
    if (!variant) {
      console.log('[ProductInfo] No valid variant found, calling setUnavailable based on original scenario.');
      this.setUnavailable(); // setUnavailable should reflect the unavailable state (e.g., hide info, disable button)
      return;
    }
    // --- End: Original Scenario Logic ---

    // If variant exists (as per original scenario), proceed with other updates
    console.log('[ProductInfo] Variant exists (based on original scenario check), proceeding with UI updates.');

    this.updateMedia(html, variant?.featured_media?.id);

    const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
      const source = html.getElementById(`${id}-${this.sectionId}`);
      const destination = this.querySelector(`#${id}-${this.dataset.section}`);
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        destination.classList.toggle('hidden', shouldHide(source));
      }
    };

    updateSourceFromDestination('price');
    updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
    // Keep original logic for Inventory updateSourceFromDestination
    updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
    updateSourceFromDestination('Volume');
    updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

    this.updateQuantityRules(this.sectionId, html);
    this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
    this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

    // --- Original Scenario Logic for updating the submit button ---
    // This part remains the same as the "Default code", updating the button
    // based on the fetched HTML's disabled state and using 'soldOut' text when disabled.
    // This preserves the original scenario's button behavior, even though isVariantAvailable was calculated.
    const submitButtonInFetchedHtml = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
    const isButtonDisabledInFetchedHtml = submitButtonInFetchedHtml?.hasAttribute('disabled') ?? true;

    console.log(`[ProductInfo] Original Scenario Button Update: Fetched button '${submitButtonInFetchedHtml?.id}' disabled: ${isButtonDisabledInFetchedHtml}. Toggling button state.`);

    this.productForm?.toggleSubmitButton(
      isButtonDisabledInFetchedHtml, // Disable/Enable based on fetched HTML
      window.variantStrings.soldOut // Use 'soldOut' text when disabled (as per default code)
      // The text when enabled will come from the button's original text in the fetched HTML,
      // as toggleSubmitButton typically doesn't change the text when enabling unless specified,
      // or it uses the default text if the disabled state matches the first argument.
      // Let's assume toggleSubmitButton handles text appropriately based on disabled state and the provided string.
    );
    // --- End: Original Scenario Logic ---


    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.sectionId,
        html,
        variant,
        // Optionally include isVariantAvailable in the published data
        isVariantAvailable: isVariantAvailable,
      },
    });
  };
}

      /**
       * Updates variant inputs, toggles delivery message based on actual availability,
       * AND ensures the "Add to Cart" button always shows "Add to Cart" and is enabled.
       */
      updateVariantInputs(variantId, isAvailable) { // isAvailable is the true availability
        console.log(`[ProductInfo] updateVariantInputs called with variantId: ${variantId}, isAvailable: ${isAvailable}`);
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (input) {
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Handle delivery message based on actual availability
        const deliveryMsg = this.querySelector('.delivery-delay-message');
        const inStock = this.querySelector('.inStock');
        if (deliveryMsg) {
          if (isAvailable) {
            console.log('[ProductInfo] updateVariantInputs: isAvailable is TRUE, removing hidden class from delivery message.');
            deliveryMsg.classList.add('hidden');
            inStock.classList.remove('hidden');
          } else {
            console.log('[ProductInfo] updateVariantInputs: isAvailable is FALSE, adding hidden class to delivery message.');
            deliveryMsg.classList.remove('hidden');
            inStock.classList.add('hidden');
          }
        } else {
          console.warn('[ProductInfo] .delivery-delay-message element not found for toggling.');
        }

        // ALWAYS set the product form button to "Add to Cart" and enabled
        if (this.productForm) {
           console.log('[ProductInfo] updateVariantInputs: Setting submit button to active/Add to cart.');
           this.productForm.toggleSubmitButton(
             false, // false means not disabled (i.e., enabled)
             window.variantStrings.addToCart || 'Add to cart' // Always use "Add to cart" text
           );
        }
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

   /**
       * Called when a variant is determined to be truly unavailable.
       * Hides certain info sections but ensures "Add to Cart" button remains active.
       */
      setUnavailable() {
        console.log('[ProductInfo] setUnavailable called (variant is determined NOT available).');

        // ALWAYS set the product form button to "Add to Cart" and enabled
        if (this.productForm) {
            console.log('[ProductInfo] setUnavailable: Setting submit button to active/Add to cart.');
            this.productForm.toggleSubmitButton(
                false, // false means not disabled (i.e., enabled)
                window.variantStrings.addToCart || 'Add to cart' // Always use "Add to cart" text
            );
        }

        // Hide other informational elements as before
        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');

        const elementsToHide = this.querySelectorAll(selectors);
        elementsToHide.forEach((el) => el.classList.add('hidden'));
        console.log(`[ProductInfo] In setUnavailable, hid ${elementsToHide.length} informational elements.`);
        // Delivery message visibility is now solely handled by updateVariantInputs based on the true 'isAvailable' state.
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        if (!this.quantityInput) return; // Guard clause
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;
        if (max !== null && max >= min) { // Ensure max is not less than min
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
        }
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;
        const loadingSpinner = this.querySelector('.quantity__rules-cart .loading__spinner');
        loadingSpinner?.classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => loadingSpinner?.classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput || !this.quantityForm) return; // Guard clause
        this.setQuantityBoundries();
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        if (!quantityFormUpdated) return; // Ensure the updated form exists in fetched HTML

        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
        this.setQuantityBoundries(); // Re-apply boundaries after updates
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        // Ensure this.dataset.section is available
        return this.dataset.section ? document.querySelector(`#ProductModal-${this.dataset.section}`) : null;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      // get relatedProducts() { ... } // Assuming SectionId is defined elsewhere
      // get quickOrderList() { ... } // Assuming SectionId is defined elsewhere

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

// Ensure PUB_SUB_EVENTS, subscribe, publish, HTMLUpdateUtility, and SectionId are defined globally
// or imported if this is part of a module system.
// For example, you might have:
// const PUB_SUB_EVENTS = { /* ... */ };
// function subscribe(event, callback) { /* ... */ return () => {}; }
// function publish(event, data) { /* ... */ }
// class HTMLUpdateUtility { static viewTransition() { /* ... */ } }
// class SectionId { /* ... */ }
// window.variantStrings = window.variantStrings || { soldOut: 'Sold out', unavailable: 'Unavailable', addToCart: 'Add to cart' };